import React from 'react';
import { AlertTriangle, DollarSign, RefreshCw, ShoppingBag } from 'lucide-react';
import { motion } from 'framer-motion';

const risks = [
  { icon: AlertTriangle, title: 'Brand Hijacking', desc: 'No trademark = no legal claim. Anyone can use your brand name and you can\'t stop them.' },
  { icon: DollarSign, title: 'Expensive Legal Battles', desc: 'Defending an unregistered brand costs 10x more than just filing. The math doesn\'t lie.' },
  { icon: RefreshCw, title: 'Forced Rebranding', desc: 'If someone files your name first, you lose it. Your domain, marketing, packaging — all gone.' },
  { icon: ShoppingBag, title: 'Amazon Lockout', desc: 'No trademark = no Brand Registry. No Brand Registry = no A+ Content, no Sponsored Brands, no IP tools.' },
];

const CostOfInactionSection = () => (
  <section data-testid="cost-inaction-section" className="py-24 md:py-32 bg-stone-900 overflow-hidden">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <div className="grid lg:grid-cols-2 gap-16 items-center">
        <motion.div initial={{ opacity: 0, x: -80 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true, margin: "-100px" }} transition={{ duration: 0.7, ease: [0.25, 0.46, 0.45, 0.94] }}>
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-orange-500 block mb-4">The Risk Is Real</span>
          <h2 className="font-serif text-4xl sm:text-5xl tracking-tight text-stone-50 leading-tight mb-4">The Price of <span className="italic text-orange-500">Waiting</span></h2>
          <p className="text-stone-400 leading-relaxed mb-8">Every day without federal trademark protection is a day your brand is exposed. These are not hypotheticals.</p>
          <div className="overflow-hidden border-2 border-stone-700 shadow-[6px_6px_0px_#44403c]">
            <img src="https://images.unsplash.com/photo-1589330694653-ded6df03f754?w=600&h=350&fit=crop" alt="Legal protection" className="w-full h-56 object-cover opacity-70" />
          </div>
        </motion.div>

        <motion.div initial={{ opacity: 0, x: 80 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true, margin: "-100px" }} transition={{ duration: 0.7, ease: [0.25, 0.46, 0.45, 0.94], delay: 0.15 }}
          className="grid grid-cols-2 gap-px bg-stone-700 border-2 border-stone-700">
          {risks.map((risk, i) => (
            <div key={risk.title} data-testid={`risk-card-${risk.title.toLowerCase().replace(/\s/g, '-')}`}
              className="group p-8 bg-stone-900 cursor-default transition-all duration-200 hover:bg-stone-800">
              <div className="w-11 h-11 bg-stone-800 border-2 border-stone-700 flex items-center justify-center mb-5 group-hover:bg-orange-600 group-hover:border-orange-600 transition-all duration-200">
                <risk.icon className="w-5 h-5 text-orange-500 group-hover:text-white transition-colors duration-200" strokeWidth={1.5} />
              </div>
              <h3 className="font-sans text-lg font-bold text-stone-50 mb-2 group-hover:text-orange-400 transition-colors duration-200">{risk.title}</h3>
              <p className="text-sm text-stone-400 leading-relaxed group-hover:text-stone-300 transition-colors">{risk.desc}</p>
            </div>
          ))}
        </motion.div>
      </div>
    </div>
  </section>
);
export default CostOfInactionSection;
